import React from "react";
import "./ExperienceCard.css";

function ExperienceCard({ experience, index, totalCards }) {
  const isLast = index === totalCards - 1;

  return (
    <article className="career-entry">
      <div className="career-entry-rail" aria-hidden="true">
        <span>{String(index + 1).padStart(2, "0")}</span>
        {!isLast && <i />}
      </div>

      <div className="career-entry-emblem">
        <img
          src={require(`../../assets/images/${experience.logo_path}`)}
          alt={`${experience.company} logo`}
        />
      </div>

      <div className="career-entry-surface">
        <div className="career-entry-topline">
          <span className="career-entry-system">
            ROLE / {String(index + 1).padStart(2, "0")}
          </span>
          <span className="career-entry-duration">{experience.duration}</span>
        </div>
        <div className="career-entry-heading">
          <div>
            <h3>{experience.title}</h3>
            <a
              href={experience.company_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {experience.company} <span>↗</span>
            </a>
          </div>
          <p className="career-entry-location">
            <i /> {experience.location}
          </p>
        </div>
        <p className="career-entry-description">{experience.description}</p>
        <div className="career-entry-footer">
          <span>
            <i /> ARCHITECTURE · DELIVERY · OUTCOMES
          </span>
          <a
            href={experience.company_url}
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit company <b>↗</b>
          </a>
        </div>
      </div>
    </article>
  );
}

export default ExperienceCard;
